<template>
  <v-container fluid class="pt-6 pl-7 pr-6">
    <v-row>

      <!-- Instance data selector section -->
      <v-col cols="12" md="5">
        <v-sheet elevation="8">

          <v-container>
            <v-row>

              <v-col cols="12" class="pb-0">
                <v-combobox
                  v-model="selBucket"
                  :items="selBucketItems"
                  @change="getFilmList"
                  label="Bucket"
                  dense
                  solo
                ></v-combobox>
              </v-col>

              <v-col cols="12" class="pb-0">
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :return-value.sync="studyDates"
                  transition="scale-transition"
                  min-width="290px"
                  offset-y
                  dense
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      label="Study Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker 
                    v-model="studyDates" 
                    color="primary" 
                    scrollable 
                    no-title 
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="red lighten-2" @click="$refs.dateMenu.save([])">Clear</v-btn>
                    <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="saveDates($refs.dateMenu);">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" class="pb-0">
                <v-text-field 
                  v-model="patientId" 
                  label="Patient ID"
                  v-on:keyup.13="search"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" class="pb-0">
                <v-text-field 
                  v-model="patientName" 
                  label="Patient Name"
                  v-on:keyup.13="search"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" class="pb-0">
                <v-text-field 
                  v-model="accessionNo" 
                  label="Accession Number"
                  v-on:keyup.13="search"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="studies"
                  item-key="accessionNo"
                  single-select
                  fixed-header
                  height="600px"
                  hide-default-footer
                  :items-per-page="100"
                  show-select
                  dense
                >
                </v-data-table>
              </v-col>

            </v-row>
          </v-container>


          
        </v-sheet>
      </v-col>

      <!-- Image box section-->
      <v-col cols="12" md="7">
        <v-sheet class="pb-1" elevation="8">

          <div v-if="imagesBoxSkeleton===false">
            <!-- Films slider -->
            <v-slide-group class="pt-4" v-model="selFilm" show-arrows mandatory>
              <v-slide-item
                v-for="n in filmsCount"
                :key="n"
                v-slot="{ active, toggle }"
              >
                <v-card
                  :color="active ? 'primary' : 'grey lighten-1'"
                  class="ma-2"
                  height="110"
                  width="110"
                  @click="toggle"
                  align="center"
                >
                  <v-img :src="getLowImagePath(n)" max-width="100" max-height="100"></v-img>
                </v-card>
              </v-slide-item>
            </v-slide-group>

            <!-- Main film image -->
            <v-card
              :loading="imageLoading"
              class="mt-6 mb-4 mx-auto"
              max-width="500"
              :tile=true
            >
              <template slot="progress">
                <v-progress-linear height="6" indeterminate></v-progress-linear>
              </template>

              <zoom-on-hover :img-normal="selImagePath"></zoom-on-hover>

              <v-card-actions>
                <v-btn color="red lighten" @click="remove" text>Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green lighten" @click="dicomize" text>Dicomize</v-btn>
              </v-card-actions>
            </v-card>
          </div>

          <div v-else>
            <v-skeleton-loader class="pt-6 pl-14 pr-14" height="180" type="image"></v-skeleton-loader>
            <v-skeleton-loader class="pt-14 pb-6 mx-auto" max-width="400" type="image, actions"></v-skeleton-loader>
          </div>

        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import EventBus from "../event-bus";

export default {
  name: "Printer",
  components: {},
  props: {},
  data: () => ({
    // bucket selector
    buckets: [],
    selBucket: null,
    selBucketItems: [],
    // images box
    imageLoading: false,
    imagesBoxSkeleton: true,
    films: [],
    selFilm: null,
    // study selector
    tableLoading: false,
    selected: [],
    studyDates: [],
    dateMenu: false,
    patientId: null,
    patientName: null,
    accessionNo: null,
    equipments: [],
    studies: [],
    headers: [
      { text: 'Patient ID', value: 'patientId' },
      { text: 'Patient Name', value: 'patientName' },
      { text: 'Accession No', value: 'accessionNo' },
      { text: 'Study Date', value: 'studyDate' },
    ]
  }),
  computed: {
    filmsCount() {
      return this.films.length;
    },
    selImagePath() {
      if(this.selFilm !== null) {
        return "/api/v1/printscp/films/"+this.films[this.selFilm].id+"/images/high";
      }else{
        return "";
      }
    },
    dateRangeText() {
      this.flipDates();

      // format date display
      let date1 = this.formatDate(this.studyDates[0]);
      let date2 = this.formatDate(this.studyDates[1]);
      if (date1 != null) {
        if (date2 == null) {
          return date1 + "~" + date1;
        }else{
          return date1 + "~" + date2;
        }
      }else{
        return "";
      }
    }
  },
  methods: {
    flipDates() {
      let date0 = new Date(this.studyDates[0]);
      let date1 = new Date(this.studyDates[1]);

      if(date0>date1) {
        let tmp = this.studyDates[0];
        this.studyDates[0] = this.studyDates[1];
        this.studyDates[1] = tmp;
      }
    },
    getBucketList() {
      axios({ url: "/api/v1/printscp/buckets", method: "GET" })
        .then((resp) => {
          if (resp.data || resp.data.status || resp.data.status == "done") {
            this.buckets = resp.data.buckets;
            this.buckets.forEach(bucket => this.selBucketItems.push(bucket.aeTitle));
          } else {
            EventBus.$emit("SHOW_ERROR", resp.data.error);
          }
        })
        .catch((error) => {
          this.sendError(error);
        });
    },
    getFilmList() {
      axios({ url: "/api/v1/printscp/buckets/"+this.selBucket+"/films", method: "GET" })
        .then((resp) => {
          if (resp.data || resp.data.status || resp.data.status == "done") {
            this.films = resp.data.films;
            this.imagesBoxSkeleton = false;
            console.log(this.films);
          } else {
            EventBus.$emit("SHOW_ERROR", resp.data.error);
          }
        })
        .catch((error) => {
          this.sendError(error);
        });

      for (let i=0; i<this.buckets.length; i++) {
        if(this.buckets[i].aeTitle == this.selBucket) {
          this.equipments = this.buckets[i].equipments;
          break;
        }
      }
    },
    getLowImagePath(n) {
      return "/api/v1/printscp/films/"+this.films[n-1].id+"/images/low";
    },
    formatDate(date) {
      if (!date) return null;
      let [year, month, day] = date.split("-");
      year = year.slice(-2);
      return `${day}/${month}/${year}`;
    },
    saveDates(dateMenu) {
      if(this.studyDates.length == 1) {
        this.studyDates[1] = this.studyDates[0];
      }
      dateMenu.save(this.studyDates);
    },
    toISODate(src) {
      var yyyy = src.getFullYear();
      var mm = String(src.getMonth() + 1).padStart(2, '0');
      var dd = String(src.getDate()).padStart(2, '0');

      return yyyy + '-' + mm + '-' + dd;
    },
    search() {
      if(this.equipments.length) {
        this.tableLoading = true;

        axios({
          url: "/api/v1/printscp/studies",
          method: "POST",
          data: {
            equipments: this.equipments,
            studyDate: this.formatDicomDate(this.studyDates),
            patientId: this.patientId ? this.patientId : "",
            patientName: this.patientName ? this.patientName : "",
            accessionNo: this.accessionNo ? this.accessionNo : "",
          },
        }).then((resp) => {
          this.tableLoading = false;
          if(resp.data || resp.data.status || resp.data.status == "done") {
            this.studies = resp.data.studies;
          } else {
            EventBus.$emit("SHOW_ERROR", resp.data.error);
          }
        }).catch((error) => {
          this.tableLoading = false;
          this.sendError(error);
        });
      }
    },
    formatDicomDate(source) {
      if (source.length == 2) {
        let [syear, smonth, sday] = source[0].split("-");
        let [eyear, emonth, eday] = source[1].split("-");
        return syear + smonth + sday + "-" + eyear + emonth + eday;
      }else{
        return "";
      }
    },
    dicomize() {

    },
    remove() {

    },
  },
  mounted() {
    // set initial search studies date
    let now = new Date();
    let now_iso = this.toISODate(now);
    this.studyDates = [now_iso, now_iso];
    // populate buckets selector
    this.getBucketList();
  }
};
</script>

<style scoped>
</style>